import React from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';

import {IWebhook, webhookAPI} from 'entities/notification';
import {userSelector} from 'entities/user';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import InputUrl from 'shared/ui/Input/InputUrl';

import NotifyChannelSection from '../NotifyChannel/NotifyChannelSection';
import NotifyChannelRow from '../NotifyChannel/NotifyChannelRow';
import NotifyChannelEditModal from '../NotifyChannel/NotifyChannelEditModal';
import NotifyChannelDeleteModal from '../NotifyChannel/NotifyChannelDeleteModal/NotifyChannelDeleteModal';

import WebhookModal from './WebhookModal';

const Webhooks: React.FC = () => {
    const user = useSelector(userSelector);

    const renderRow = (item: IWebhook) => (
        <NotifyChannelRow
            key={item.id}
            item={item}
            title={item.url}
            api={webhookAPI}
            activatedText={t`Вебхук активирован`}
            deactivatedText={t`Вебхук деактивирован`}
            renderEditModal={(modal) => (
                <NotifyChannelEditModal
                    {...modal}
                    item={item}
                    api={webhookAPI}
                    header={t`Редактирование вебхука`}
                    successText={t`Вебхук успешно обновлён`}
                    extraValues={{url: item.url || ''}}
                    renderExtraFields={({control, register, formState: {errors}}) => (
                        <FormGroupWithError
                            label="URL"
                            error={errors.url?.message}
                        >
                            <InputUrl
                                control={control}
                                name="url"
                                placeholder="https://example.com/hooks/overseer"
                                register={register}
                            />
                        </FormGroupWithError>
                    )}
                />
            )}
            renderDeleteModal={(modal) => (
                <NotifyChannelDeleteModal
                    {...modal}
                    item={item}
                    api={webhookAPI}
                    header={t`Удаление вебхука`}
                    question={t`Вы уверены, что хотите удалить вебхук`}
                    name={item.description || item.url}
                    successText={t`Вебхук удалён`}
                />
            )}
        />
    );

    return (
        <NotifyChannelSection
            api={webhookAPI}
            title={t`Вебхуки для уведомлений`}
            limit={user?.tariff.webhook_max_count_limit}
            firstColumn={{label: 'URL', sort: 'url'}}
            create={{label: t`Добавить вебхук`, exceededType: 'webhooks', Modal: WebhookModal}}
            renderRow={renderRow}
            last
        />
    );
};

export default Webhooks;
